module.exports = __webpack_public_path__ + "img/refer-illustration-mobile.b39df040.png";